import http from 'hub-http/clients/apiClient';

// Example Response https://tools.hubteamqa.com/api/request/7d80c1c8ce424c2ea8a5fec2673700b8

export const fetchSmsCampaignDetails = ({
  contentId
}) => {
  return http.get(`/messaging-sms/v1/details/${contentId}`);
};